import DealHero from "../components/deals/deal-hero";

function Deals() {
    return(<div><DealHero/></div>)
}

export default Deals;